module.exports = __webpack_public_path__ + "static/media/rating-star-full.f88c5137.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/rating-star-full.svg
// module id = 810
// module chunks = 0